import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const browserLang = navigator.language.split('-')[0];
const supportetLangs = [ 'de', 'en' ];
const defaultLang = 'en';

const messages = {
    'de': {
        portrait: {
            row1: {
                title: 'Wir haben Kapital',
                text: 'Der eine hat die Idee, auf die die Welt gewartet hat. Der andere hat das Kapital und das Know-how. So wird aus der Idee ein Geschäft, ein marktfähiges Produkt, eine Dienst&shy;leistung. Der eine sind vielleicht Sie. Sicher ist: Wir sind der andere. Als Unternehmer investieren wir in Businessideen und Start-ups. Bei Bedarf nutzen wir unser Netzwerk an Fachleuten und weiteren Investoren. Was auch immer Sie Einzigartiges auf dem Papier haben, gemeinsam bringen wir es zum Fliegen.',
            },
            row2: {
                title: 'Wir haben Ahnung',
                text: 'Eine tolle Idee und Startkapital – schön und gut. Nur, um am Markt langfristig zu bestehen, braucht es mehr: nämlich betriebswirt&shy;schaftliche Expertise und Erfah&shy;rung. Beides haben wir. Wir wissen, was es heisst, ein Unter&shy;nehmen aufzubauen und zum Erfolg zu führen. Wir sind nicht bloss Investoren. Vielmehr machen wir aus Geschäftsideen Unter&shy;nehmen, die auch übermorgen noch gesund und munter funktio&shy;nieren. Was wir zum Fliegen bringen, halten wir in der Luft. ',
            },
            row3: {
                title: 'Wir haben Feuer',
                text: 'Wir investieren Kapital und Know-how in Ideen, die uns über&shy;zeugen. Mehr noch: in Projekte, die uns persönlich begeistern. Neben der Rendite lassen unter&shy;nehmerische Ideen unseren Puls dann höher schlagen, wenn sie auch gesell&shy;schaftlich relevant sind und scho&shy;nend mit Ressourcen umgehen. Wir sehen uns als ver&shy;antwortungsbe&shy;wusste Investoren und Unter&shy;nehmer.',
            },
        },
        contact: {
            title: 'Kontakt'
        }
    },
    'en': {
        portrait: {
            row1: {
                title: 'We have capital',
                text: 'Somebody comes up with an idea that the whole world had been waiting for. Someone else has the capital and know-how required. This is how the idea is turned into a business opportunity, a marketable product, or a service. Maybe you are that somebody. One thing is for sure: we are that someone else. As entrepreneurs, we invest in business ideas and start-ups. If required, we make use of our network of experts and other investors. No matter what unique concept you have devised, together we will help it take off.',
            },
            row2: {
                title: 'We have knowledge',
                text: 'It’s all well and good having a great idea and start-up capital. However, more is required to survive on the market in the long term: namely business expertise and experience. We have both. We know what it means to build up a company and lead it to success. We aren’t just investors but rather we turn business ideas into companies which remain alive and kicking in the long term. Whatever we help take off, we keep afloat.',
            },
            row3: {
                title: 'We have passion',
                text: 'We invest capital and know-how in ideas which impress us. But more than that: we invest in projects which we are personally enthusiastic about. Apart from the return, business ideas make our pulse race if they are also socially relevant and use resources responsibly. We see ourselves as responsible investors and entrepreneurs. ',
            },
        },
        contact: {
            title: 'Contact'
        }
    }
};

const i18n = new VueI18n({
    locale: supportetLangs.indexOf(browserLang) > -1 ? browserLang : defaultLang,
    messages,
});

export default i18n;
